<template>
  <article class="OrderProduct">
    <div class="OrderProduct__content">
      <img class="OrderProduct__picture" :src="thumbURL" />
      <div>
        <div class="OrderProduct__producer">
          {{ producer }}
        </div>
        <div class="OrderProduct__name">
          {{ name }} {{ year }}<br />
          {{ additional_name }}
        </div>
        <div class="OrderProduct__tags">
          <div class="Tag" v-if="freeBtls">{{ quantity }}+{{ freeBtls }} {{ "gratuite" | pluralize(freeBtls) }}</div>
        </div>
      </div>
      <div class="OrderProduct__footer">
        <div class="OrderProduct__quantity"> {{ priceFormat(price) }}€x{{ quantity }}</div>
        <Price :price="price * quantity" />
      </div>
    </div>
  </article>
</template>
<script>
import orderLineMixin from "../mixins/orderLineMixin";
import priceFormat from "../utils/priceFormat";

export default {
  name: "OrderLine",
  mixins: [orderLineMixin],
  props: {
    freeBtls: {
      type: Number,
      default: 0
    }
  },
  methods: {
    priceFormat
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/variables";

.OrderProduct {
  background: #fff;
  border-radius: $global-radius;
  margin-bottom: $global-margin/2;
  border: 1px solid $color-smoke;
  text-align: left;
  transition: all 0.2s ease-in-out;

  &__content {
    flex: 1 0 50%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: $global-margin/3 $global-margin;
    border-radius: $global-radius;
  }

  &__footer {
    margin-left: auto;
    text-align: right;
  }

  &__producer {
    font-weight: 500;
    font-size: 0.65rem;
    margin-bottom: 0.2rem;
    text-transform: capitalize;
  }

  &__name {
    font-weight: 700;
    font-size: 0.75rem;
    margin-bottom: $global-margin / 2;
  }

  &__picture {
    flex: 0 0 auto;
    max-height: 3.375rem;
    margin: -2px $global-margin -2px 0;
  }

  &__quantity {
    font-size: 0.75rem;
  }

  &__status {
    font-size: 0.73rem;

    &--canceled {
      color: red;
    }

    &--sent {
      color: $color-label-green;
    }

    &--ordered {
      color: $color-primary;
    }
  }

  @media (min-width: 900px) {
    display: flex;
    align-content: center;
    justify-content: space-between;
  }
}
</style>
